import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 搜索事件名称常量
export const SEARCH_EVENT_NAMES = {
  SEARCH_FETCH_START: 'search_fetch_start',
  SEARCH_FETCH_NO_DATA: 'search_fetch_no_data',
  SEARCH_BACK_FETCH_START: 'search_back_fetch_start',
  SEARCH_BACK_NO_DATA: 'search_back_no_data',
  SEARCH_SUG_FETCH_START: 'search_sug_fetch_start',
  SEARCH_SUG_N0_DATA: 'search_sug_no_data',
  SEARCH_FILTER_FETCH_START: 'search_filter_fetch_start',
  SEARCH_FILTER_NO_DATA: 'search_filter_no_data',
  CATEGORY_IMG_ERROE: 'category_img_error',
  CATEGORY_FETCH_START: 'category_fetch_start',
  CATEGORY_FIRST_NO_DATA: 'category_first_no_data',
  CATEGORY_SECOND_NO_DATA: 'category_second_no_data',
  CATEGORY_THIRD_NO_DATA: 'category_third_no_data',
} as const;

// 导出类型定义，既可以当常量用也可以当类型用
export type SearchEventNames = typeof SEARCH_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const searchNames: string[] = [];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const searchBusinessLogger = createBusinessLogger<SearchEventNames>(
  'product_search',
  searchNames,
);
